module.exports = __webpack_public_path__ + "static/img/pedals-distortion.20c5147.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedals-distortion.png
// module id = oqao
// module chunks = 12